import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const l = t((o, e) => /* @__PURE__ */ r.jsx(
  s,
  {
    ref: e,
    ...o,
    image: (i) => /* @__PURE__ */ r.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...i,
        children: /* @__PURE__ */ r.jsx("rect", { width: 16, height: 16, fill: "currentColor", rx: 8 })
      }
    )
  }
));
l.displayName = "CircleIcon";
export {
  l as CircleIcon,
  l as default
};
//# sourceMappingURL=index.js.map
